import React from "react";
import { useNavigate } from "react-router-dom";

const AdmissionEnrollment = () => {
  const navigate = useNavigate();

  return (
    <section className="menu-section-bg">
      <div className="menu-container">

        {/* ===== HEADER ===== */}
        <div className="product-subtitleBg-header">
          <h1 className="product-titleBg">Admission & Enrollment</h1>
          <p className="product-subtitleBg">
            Digitize your complete{" "}
            <span className="ps-text-highlight">admission lifecycle</span> — from{" "}
            <span className="ps-text-alt">inquiry</span> to{" "}
            <span className="ps-text-alt">enrollment</span> — with a{" "}
            <strong className="ps-text-strong">
              seamless, transparent, and efficient system
            </strong>.
          </p>
        </div>

        {/* ===== SECTION 1 ===== */}
        <div className="product-and-sol-lastCard ps-two-column-grid product-sol-card">
          <div className="enrollment-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/Admission&Enrollment.jpg"
              alt="Admission Process"
              className="ps-main-image"
            />
          </div>

          <div>
            <h2 className="product-and-sol-sectionTitle">
              Smart Admission Management
            </h2>
            <p className="product-and-sol-section-text">
              Simplify student onboarding with automated forms, document uploads,
              real-time application tracking, and secure approvals — all from a
              centralized dashboard.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Online application & inquiry forms</li>
              <li>✔ Document upload & verification</li>
              <li>✔ Admission status tracking</li>
              <li>✔ Seat availability management</li>
            </ul>

            <div
              className="read-more-btn"
              onClick={() =>
                navigate("/admission-enrollment/read-more#Revolutionize")
              }
            >
              Read more →
            </div>
          </div>
        </div>

        {/* ===== SECTION 2 (REVERSED CONTENT) ===== */}
        <div className="product-and-sol-secondCard ps-two-column-grid product-sol-card">
          <div>
            <h2>
              Why Admissions and Enrollment Software Is Essential
            </h2>
            <p className="product-and-sol-section-text">
              Traditional paper-based processes are outdated, error-prone, and
              time-consuming. Families expect digital convenience while schools
              need data-driven insights to compete for students.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Reducing administrative burden</li>
              <li>✔ Improving family engagement</li>
              <li>✔ Enhancing data security</li>
              <li>✔ Boosting enrollment rates</li>
              <li>✔ Cost savings</li>
            </ul>

            <div
              className="read-more-btn"
              onClick={() =>
                navigate("/admission-enrollment/read-more#why-admission")
              }
            >
              Read more →
            </div>
          </div>

          <div className="addmission-Unlock-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/Admission&Enrollment1.jpg"
              alt="Enrollment System"
              className="ps-main-image"
            />
          </div>
        </div>

        {/* ===== FEATURES ===== */}
        <div className="ps-feature-grid">
          <FeatureCard
            typeClass="credentialing"
            backgroundColor="#e9fdf3"
            icon={icons.form}
            title="Online Admission Forms"
            description="Customizable digital admission forms that eliminate paperwork."
          />

          <FeatureCard
            typeClass="wallet"
            backgroundColor="#f3ecff"
            icon={icons.workflow}
            title="Approval Workflow"
            description="Multi-level approval workflows ensure transparency."
          />

          <FeatureCard
            typeClass="human-resources"
            backgroundColor="#f1f6ff"
            icon={icons.enrollment}
            title="Enrollment Management"
            description="Automatically convert approved applicants into students."
          />

          <FeatureCard
            typeClass="education"
            backgroundColor="#fff3cc"
            icon={icons.analytics}
            title="Admission Analytics"
            description="Track application trends and intake performance."
          />
        </div>

        {/* ===== CTA ===== */}
        <div className="ps-highlight-wrapper">
          <div className="ps-highlight-card">

            <div className="ps-highlight-header">
              <h2 className="ps-highlight-title">
                Make Admissions Faster & Smarter
              </h2>
              <p className="ps-highlight-subtitle">
                A seamless experience for schools and families
              </p>
            </div>

            <div className="ps-highlight-body">
              <p className="ps-highlight-text">
                Reduce manual work, improve accuracy, and deliver a smooth
                enrollment experience for students and parents.
              </p>

              <div className="ps-button-group">
                <button
                  className="Demo-button"
                  onClick={() => navigate("/contact#Contact-form")}
                >
                  Request a Demo
                </button>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

/* ===== SHARED FEATURE CARD ===== */
const FeatureCard = ({
  icon,
  title,
  description,
  typeClass,
  backgroundColor
}) => (
  <div
    className={`card product-soluction-card ${typeClass}`}
    style={{ backgroundColor }}
  >
    <div className="card-overlay"></div>

    <div className="circle">
      <div className="ps-card-icon">{icon}</div>
    </div>

    <h3 className="ps-card-title">{title}</h3>
    <p className="product-soluction-card-text">{description}</p>
  </div>
);

/* ===== ICONS ===== */
const icons = {
  form: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="3" width="16" height="18" rx="2" stroke="#5a5cff" strokeWidth="2" />
      <path d="M8 7h8M8 11h8M8 15h5" stroke="#5a5cff" strokeWidth="2" />
    </svg>
  ),
  workflow: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <circle cx="6" cy="6" r="3" stroke="#ff8c00" strokeWidth="2" />
      <circle cx="18" cy="6" r="3" stroke="#ff8c00" strokeWidth="2" />
      <circle cx="12" cy="18" r="3" stroke="#ff8c00" strokeWidth="2" />
      <path d="M8.5 7.5L11 15M15.5 7.5L13 15" stroke="#ff8c00" strokeWidth="2" />
    </svg>
  ),
  enrollment: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 19V7l8-4 8 4v12" stroke="#0ca85c" strokeWidth="2" />
      <path d="M9 22v-6h6v6" stroke="#0ca85c" strokeWidth="2" />
    </svg>
  ),
  analytics: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 20V10M10 20V4M16 20v-8" stroke="#e74c3c" strokeWidth="2" />
    </svg>
  ),
};

export default AdmissionEnrollment;
